var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_vm._l((_vm.aboutNetwork),function(item,i){return [_c('v-col',{key:i,attrs:{"cols":"6","md":"4"}},[_c('NetworkCard',{attrs:{"img":item.image_path},on:{"onPress":function($event){return _vm.openLink(item.url)}}})],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }